import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  AvatarStack,
  Avatar,
  Button,
  fonts,
  Divider,
  Modal,
  ModalHeader,
  ModalCloseButton,
  DisplayExtraSmall,
  ProductPreview,
  BodyLargeRegular
} from 'prospect-path-base';

import { userInitials } from '../../../tools/user-initials';


const { body } = fonts;
const { largeRegular } = body;

const CaptionText = styled.span`
  ${largeRegular}
  color: #757575;
  margin: auto 0; 
`;

const avatarColors = [
  '#EBF4F5',
  '#F1F2FB',
  '#FEF9EB',
];

const CreateTeamModal = ({ closeTeamModal, team, checkTeam, user, ...props }) => {
  if (!props.isOpen) {
    return '';
  }

  const getUserInitials = (name) => {
    let displayName = name;

    if (displayName === null || typeof displayName === 'undefined' || displayName === '') {
      displayName = team.name;
    }

    return userInitials(name);
  }

  return (
    <Modal
      {...props}
    >
      <ModalHeader
        title={<DisplayExtraSmall as="h1">{team.name}</DisplayExtraSmall>}
        close={<ModalCloseButton onClick={closeTeamModal} />}
      />

      <div style={{ display: 'flex' }}>
        <AvatarStack
          key={team.id}
          style={{ flex: 1 }}
          avatars={
            team.users.map(( user, index ) => (
              <Avatar
                initials={getUserInitials(user.name)}
                size={35}
                style={{ backgroundColor: avatarColors[index%avatarColors.length] }}
              />
            ))
          }
        />

        <CaptionText>
          {team.user_count} members
        </CaptionText>
      </div>

      <Divider style={{ marginTop: '1.25rem', marginBottom: '1rem' }} />

      {team.products.map(product => (
          <div style={{ marginBottom: '1rem' }}>
            <ProductPreview image={<img style={{ 'height': '2.5rem', 'width': '2.5rem' }} src={product.clearbit_logo} />} title={<BodyLargeRegular>{product.name}</BodyLargeRegular>} />
          </div>
      ))}

      <Button
        size="large"
        block
        onClick={() => checkTeam(team)}
      >
        Select team
      </Button>
    </Modal>
  )
}

CreateTeamModal.propTypes = {
  onCloseButtonClicked: PropTypes.func
};

export default CreateTeamModal;
